/* @flow */

import * as React from 'react';
import { ErrorMessage, Field } from 'formik';

import styles from './FormikCheckbox.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import Checkbox from 'src/shared/ui/component/form/Checkbox';

type Props = {
  name: string,
  value?: string,
  text: string,
  icon?: React.Node,
  'aria-describedby'?: string,
};

const useStyles = createUseThemeStyles(styles);

const FormikCheckbox = ({
  value,
  name,
  text,
  icon,
  'aria-describedby': ariaDescribedby,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();
  const errorId = `${name}-error`;
  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <>
      <Field name={name} value={value}>
        {({ field }) => (
          <Checkbox
            {...field}
            onChange={(e) => field.onChange(e)}
            checked={field.checked}
            text={text}
            icon={icon}
            aria-describedby={ariaDescribedby}
          />
        )}
      </Field>
      <ErrorMessage name={name}>
        {(e) => (
          <div className={classes.error} aria-live="assertive" id={errorId}>
            {e}
          </div>
        )}
      </ErrorMessage>
    </>
  );
};

export default React.memo<Props>(FormikCheckbox);
